import { createStyles } from '../../core/withStyles';
import { marginBetweenChildrenVertical } from '../../mixins';
const styles = (theme) => createStyles({
    root: Object.assign(Object.assign({ display: 'flex', flexDirection: 'column', width: '100%', minHeight: 0 }, marginBetweenChildrenVertical(theme.spacing(1))), { '& > *': {
            flexShrink: 0,
        } }),
    clickable: {
        cursor: 'pointer',
    },
    inline: {
        display: 'inline-flex',
        width: 'auto',
    },
    doubleMargin: Object.assign({}, marginBetweenChildrenVertical(theme.spacing(2))),
});
export default styles;
//# sourceMappingURL=Column.styles.js.map